import React from "react";
import { motion } from "framer-motion";
import { PARTNERS } from "../data/content";

const Marquee = () => {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section
      className="py-12 border-y border-border bg-card overflow-hidden"
      data-testid="partners-marquee"
    >
      <div className="container mb-6 flex items-center justify-between">
        <div className="overline text-muted-foreground">— Trusted by</div>
        <div className="font-mono text-xs text-muted-foreground hidden md:block">
          Strategic partners across Nigeria's energy ecosystem
        </div>
      </div>
      <div className="relative">
        <div className="flex gap-16 whitespace-nowrap animate-marquee will-change-transform">
          {items.map((p, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.05, color: "hsl(var(--primary))" }}
              className="font-display font-bold text-2xl md:text-4xl text-foreground/40 hover:text-primary transition-colors"
            >
              {p}
            </motion.div>
          ))}
        </div>
        {/* Side fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-card to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-card to-transparent" />
      </div>
    </section>
  );
};

export default Marquee;
